import { RoutesList } from '@/routes/routesList';
import { useLocation } from 'react-router-dom';

const useIsDailyPlanPage = (isInDayMode?: boolean): boolean => {
  const isDailyPlanPage = useLocation().pathname === RoutesList.MyPlanDailyPage;

  // If we're in CategorySpotlight with day mode selected, treat it as daily plan page
  return isDailyPlanPage || Boolean(isInDayMode);
};

export default useIsDailyPlanPage;
